import { FilterMatchMode } from "primereact/api"

export class Causa {
    model = {
        id: { value: null, export: false },
        idp: { value: null, export: false },
        causa: {
            header: 'CAUSA DEL RIESGO',
            value: null,
            required: 'Selecione una opcion',
            optionLabel: 'nombre',
            export: false,
            filterPlaceholder: 'Búsqueda',
            filterField: 'causa',
            filter: true,
            sort: true,
            table: true,
            matchMode: FilterMatchMode.CONTAINS
        },
    }
}
